<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">TERMİNALLER</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active">Terminaller</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="terminals$ | async" [paginator]="true" [rows]="25" [(selection)]="selectedRecords"
            [rowsPerPageOptions]="[5,10,25,50,100,500,1000,2000]" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['terminalId','imei','portalName','deviceModelName','terminalStatusName','customerName','organizationName','projectName']"
            [responsive]="true">
            <ng-template pTemplate="caption">
                <button pButton type="button" class="p-button-info" label="Yeni" icon="pi pi-plus"
                    routerLink="/terminal-add"></button>
                <button pButton type="button" class="p-button-danger" label="Sil" icon="pi pi-trash"
                    (click)="showMultiDeleteDialog()"></button>
                <button type="button" pButton pRipple icon="pi pi-file-excel" class="p-button-success p-mr-2"
                    pTooltip="Dışa Aktar" tooltipPosition="bottom" label="Dışa Aktar" (click)="exportExcel()"></button>
                <button pButton type="button" class="p-button-warning" label="İçe Aktar" icon="pi pi-download"
                    (click)="showUploadDialog()"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
                <div class="text-center" *ngIf="loading">
                    <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-secondary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th pSortableColumn="terminalId" [width]="'10%'">Terminal ID<p-sortIcon field="terminalId">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="imei" [width]="'10%'">Imei<p-sortIcon field="imei">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="portalName" [width]="'10%'">Portal<p-sortIcon field="portalName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="deviceModelName" [width]="'10%'">Cihaz Modeli<p-sortIcon
                            field="deviceModelName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="terminalStatusName" [width]="'10%'">Durum<p-sortIcon
                            field="terminalStatusName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="customerName" [width]="'30%'">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>
                   
                    <th pSortableColumn="projectName" [width]="'10%'">Proje<p-sortIcon field="projectName">
                        </p-sortIcon>
                    </th>
                    <th [width]="'10%'">

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-terminals>
                <tr>
                    <td>
                        <p-tableCheckbox *ngIf="!terminals.terminalStatus" [value]="terminals"></p-tableCheckbox>
                    </td>
                    <td>{{terminals.terminalId}}</td>
                    <td>{{terminals.imei}}</td>
                    <td><span class="badge badge-info" style="font-size:1rem;">{{terminals.portalName}}</span></td>
                    <td>{{terminals.deviceModelName}}</td>
                    <td *ngIf="terminals.terminalStatus==0"><span class="badge badge-success"
                            style="font-size:1rem;">{{terminals.terminalStatusName}}</span></td>
                    <td *ngIf="terminals.terminalStatus==1"><span class="badge badge-danger"
                            style="font-size:1rem;">{{terminals.terminalStatusName}}</span></td>
                    <td>{{terminals.customerName}}</td>
                    <td>{{terminals.projectName}}</td>
                    <td>
                        <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-success" pTooltip="Güncelle" tooltipPosition="bottom"
                            routerLink="/terminal-update/{{terminals.id}}"></button>
                        <button *ngIf="terminals.terminalStatus==1" pButton pRipple type="button"
                            icon="pi pi-arrow-left" class="p-button-rounded p-button-info" pTooltip="Müşteriden Geri Al"
                            tooltipPosition="bottom" (click)="showReturnDialog(terminals.id)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog header="TERMİNAL İADE" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Terminal Müşteriden Geri Alınacak. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="displayModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="returnTerminal()" label="Geri Al" styleClass="p-button-info"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="TERMİNAL SİLME" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Terminal Silinecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="deleteTerminal()" label="Sil" styleClass="p-button-info"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="TERMİNAL GEÇMİŞİ" [(visible)]="historyModal" [modal]="true" [style]="{width: '60vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="data-grid">
        <p-table #dt [value]="histories$ | async" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
            styleClass="p-datatable-gridlines" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.." [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="operationDate" [width]="'20%'">İşlem Tarihi<p-sortIcon field="operationDate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="operation" [width]="'20%'">İşlem<p-sortIcon field="operation">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="customerCode" [width]="'20%'">Müşteri Kodu<p-sortIcon field="customerCode">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="customerName" [width]="'40%'">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-histories>
                <tr>
                    <td>{{histories.operationDate | date:"dd-MM-yyyy"}}</td>
                    <td>{{histories.operation}}</td>
                    <td>{{histories.customerCode}}</td>
                    <td>{{histories.customerName}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="historyModal=false" label="Kapat" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="TERMİNAL AKTAR" [(visible)]="uploadModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="body">
        <input type="file" (change)="onFileChange($event)" multiple="false" />
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="p-button-warning" label="Excel Template"
            (click)="exportExcelExample()"></button>
        <p-button (click)="uploadModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="chechkImport()" label="Kaydet" styleClass="p-button-info"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="TERMİNAL AKTAR" [(visible)]="importModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="body">
        <div style="text-align: center;" *ngIf="progress">
            <span class="badge badge-success" style="font-size: 1.5rem;">Terminaller oluşturuluyor. Lütfen
                bekleyiniz...</span>
            <p-progressBar [value]="value"></p-progressBar>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="AKTARIM HATASI" [(visible)]="importError" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="body">
        <span class="badge badge-danger" style="font-size: 1.5rem;">İŞLEM BAŞARISIZ! AŞAĞIDAKİ HATALAR İLE
            KARŞILAŞILDI...</span>
        <textarea [(ngModel)]="importErrorMessage" rows="10" readonly="true" style="width: 100%;"></textarea>
    </ng-template>
</p-dialog>


<p-dialog header="TOPLU TERMİNAL SİLME" [(visible)]="multiDeleteModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Terminaller Silinecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="multiDeleteModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="deleteTerminals()" label="Sil" styleClass="p-button-info"></p-button>
    </ng-template>
</p-dialog>